import { Loader2 } from "lucide-react";
import { SEND_OUTCOME_COPY, type JdSendOutcome } from "../../lib/jdSendOutcome";

export function JdSendOutcomeLine({
  fieldName,
  outcome,
}: {
  fieldName: string;
  outcome: JdSendOutcome | { kind: "sending" } | undefined;
}) {
  if (!outcome) return null;
  if (outcome.kind === "sending") {
    return (
      <p className="flex items-center gap-1 text-[11px] text-muted">
        <Loader2 size={11} className="animate-spin text-accent" /> {fieldName} —
        sending…
      </p>
    );
  }
  if (outcome.kind === "sent") {
    // BE-Light's requested post-send copy: say WHERE the file went and what the user does next
    return (
      <div className="rounded border border-emerald-500/40 bg-emerald-500/5 p-2 text-[11px]">
        <span className="block font-medium text-fg">
          {fieldName} — sent to Ops Center.
        </span>
        <span className="mt-0.5 block text-[10px] leading-snug text-muted">
          In John Deere Ops, create a work plan for {fieldName} and choose “
          {outcome.result.filename}” under Prescription.
        </span>
      </div>
    );
  }
  const copy = SEND_OUTCOME_COPY[outcome.kind];
  return (
    <div
      className={`rounded border p-2 text-[11px] ${outcome.kind === "sent_unrecorded" ? "border-amber-500/40 bg-amber-500/5" : "border-red-500/40 bg-red-500/5"}`}
    >
      <span className="block font-medium text-fg">
        {fieldName} — {copy.title}
      </span>
      <span className="mt-0.5 block text-[10px] leading-snug text-muted">
        {copy.body}
      </span>
      {outcome.kind === "failed" && (
        <span className="mt-0.5 block text-[10px] text-faint">
          {outcome.message}
        </span>
      )}
    </div>
  );
}
